export class DisplayCompany {
  static entityName = 'displayCompany';

  logoUrl?: string;
  name: string;
  websiteUrl?: string;
}
